/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {

    // Set mails flag unread to true
    createNotice({ commit }, payload) {
      // commit("SET_ACTIVE_PROJECT_TITLE", payload.title)
      var frm = new FormData()
      var noticeInfo = {"title": payload.title, "workspace_id": payload.workspaceId, "detail": payload.detail, "size": payload.files.length, "share_class": payload.share_class}
      const json = JSON.stringify(noticeInfo);
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      for (var index in payload.files) {

        frm.append(index, payload.files[index])
      }
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/notice/create", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success'){
            commit("CREATE_NOTICE", response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    updateNotice({ commit }, payload) {
      var frm = new FormData()
      var files = []
      for (var index in payload.files) {
        files.push(payload.files[index].name)
        frm.append(index, payload.files[index])
      }
      var noticeInfo = {"id": payload.id, "title": payload.title, "size": payload.files.length, "files":files,  "detail": payload.detail, "share_class": payload.share_class}
      const json = JSON.stringify(noticeInfo)
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/notice/update", frm, {headers:{'Content-Type': 'multipart/form-data'}})
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_NOTICE", response.data.data)
              resolve(response)
            }
            reject(response)
          }
        ).catch((error) => { reject(error) })
      })
    },
    deleteNoticeFile({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/notice/update/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_NOTICE", response.data.data)
              resolve(response)
            }
            reject(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    deleteNotice({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/notice/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_NOTICE", payload)
            }
            resolve(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    getNotice({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/notice/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_NOTICE_LIST", response.data.data_list)
            }
            resolve(response)
          }).catch((error) => { reject(error) })
        })
    },
    setNoticeSearchQuery({ commit }, query){
        commit("SET_NOTICE_SEARCH_QUERY", query)
    },
    noticeFileDonwload(context, payload){
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/notice/download/"+ payload.param, {responseType: 'blob'}).then((response)=>{
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          // const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ')
          link.setAttribute('download', payload.name);

          document.body.appendChild(link);
          link.click();
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    }
}
